module.exports = __webpack_public_path__ + "static/img/image@1x-4.fad2567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x-4.png
// module id = bUU6
// module chunks = 0